document.addEventListener('DOMContentLoaded', function () {

  // -- Parse product data from Liquid JSON block
  let quoteData = { products: [] };
  try {
    quoteData = JSON.parse(document.getElementById('quote-data').textContent);
  } catch (err) {
    console.error('Estimate form: Failed to parse product data:', err);
  }

  if (!quoteData.products || quoteData.products.length === 0) {
    console.warn('Estimate form: Collection "quote-request-form" is empty or does not exist.');
  }

  const loadedAtField = document.getElementById('form-loaded-at');
  if (loadedAtField) loadedAtField.value = Date.now();

  const productRows = document.getElementById('product-rows');
  const addBtn      = document.getElementById('add-product');
  const clearBtn    = document.getElementById('clear-form');
  const form        = document.getElementById('quote-request-form');
  const errorBox    = document.getElementById('form-error');
  const modal       = document.getElementById('thank-you-modal');

  // -- CAPTCHA: simple math question
  let captchaAnswer = 0;

  function generateCaptcha() {
    const a = Math.floor(Math.random() * 10) + 1;
    const b = Math.floor(Math.random() * 10) + 1;
    captchaAnswer = a + b;
    const el = document.getElementById('captcha-question');
    if (el) el.textContent = `What is ${a} + ${b}?`;
    const ans = document.getElementById('captcha-answer');
    if (ans) ans.value = '';
  }

  generateCaptcha();

  // -- Block non-numeric input in phone field
  const phoneInput = document.getElementById('contact-phone');
  if (phoneInput) {
    phoneInput.addEventListener('keypress', function (e) {
      const allowed = /[0-9+\-\s()]/;
      if (!allowed.test(e.key) && e.key !== 'Backspace') {
        e.preventDefault();
      }
    });

    phoneInput.addEventListener('paste', function (e) {
      const pasted = (e.clipboardData || window.clipboardData).getData('text');
      if (!/^[0-9+\-\s()]+$/.test(pasted)) {
        e.preventDefault();
      }
    });
  }

  // -- Render product options dynamically
  // "Size" option → Width + Height text inputs on same row
  // All other options → individual dropdown per row
  function renderOptions(container, product) {
    container.innerHTML = '';
    if (!product || !product.options.length) return;

    const sizeOptions  = product.options.filter(o => o.name.toLowerCase() === 'size');
    const otherOptions = product.options.filter(o => o.name.toLowerCase() !== 'size');

    // Width + Height on the same row
    if (sizeOptions.length > 0) {
      const sizeRow = document.createElement('div');
      sizeRow.className = 'size-row';

      ['Width', 'Height'].forEach(dim => {
        const field = document.createElement('div');
        field.className = 'size-field';

        const label = document.createElement('label');
        label.innerHTML = `<span style="color:red;">*</span> ${dim}`;

        const input = document.createElement('input');
        input.type = 'text';
        input.className = dim === 'Width' ? 'size-width-input qrf-input' : 'size-height-input qrf-input';
        input.placeholder = dim === 'Width' ? 'e.g. 24"' : 'e.g. 36"';
        input.required = true;

        field.appendChild(label);
        field.appendChild(input);
        sizeRow.appendChild(field);
      });

      container.appendChild(sizeRow);
    }

    // Each remaining option gets its own row
    otherOptions.forEach(opt => {
      const field = document.createElement('div');
      field.className = 'product-row-field';

      const label = document.createElement('label');
      label.textContent = opt.name;

      const select = document.createElement('select');
      select.className = 'dynamic-option-select qrf-select';
      select.dataset.optionName = opt.name;
      select.required = true;

      const defaultOpt = document.createElement('option');
      defaultOpt.value = '';
      defaultOpt.textContent = `Select ${opt.name}`;
      select.appendChild(defaultOpt);

      opt.values.forEach(val => {
        const o = document.createElement('option');
        o.value = val;
        o.textContent = val;
        select.appendChild(o);
      });

      field.appendChild(label);
      field.appendChild(select);
      container.appendChild(field);
    });
  }

  // -- Create a single product row
  function createProductRow() {
    const row = document.createElement('div');
    row.className = 'product-row';

    // Product dropdown
    const productField = document.createElement('div');
    productField.className = 'product-row-field';

    const productLabel = document.createElement('label');
    productLabel.textContent = 'Product';

    const productSelect = document.createElement('select');
    productSelect.className = 'product-select qrf-select';
    productSelect.required = true;

    const defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.textContent = 'Select Product';
    productSelect.appendChild(defaultOpt);

    quoteData.products.forEach(p => {
      const opt = document.createElement('option');
      opt.value = p.handle;
      opt.textContent = p.title;
      productSelect.appendChild(opt);
    });

    productField.appendChild(productLabel);
    productField.appendChild(productSelect);
    row.appendChild(productField);

    // Dynamic options container
    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'options-container';
    row.appendChild(optionsContainer);

    // Quantity field — required, default = 1
    const qtyField = document.createElement('div');
    qtyField.className = 'product-row-field';

    const qtyLabel = document.createElement('label');
    qtyLabel.innerHTML = '<span style="color:red;">*</span> Quantity';

    const qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.className = 'qty-input qrf-input';
    qtyInput.placeholder = 'e.g. 100';
    qtyInput.min = '1';
    qtyInput.value = '1';
    qtyInput.required = true;

    qtyField.appendChild(qtyLabel);
    qtyField.appendChild(qtyInput);
    row.appendChild(qtyField);

    // Remove + Add More Product on the same row
    const actions = document.createElement('div');
    actions.className = 'row-actions';

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'remove-row qrf-btn qrf-btn--danger';
    removeBtn.textContent = '– Remove';
    actions.appendChild(removeBtn);

    const addMoreBtn = document.createElement('button');
    addMoreBtn.type = 'button';
    addMoreBtn.className = 'add-more-product qrf-btn qrf-btn--add';
    addMoreBtn.textContent = '+ Add More Product';
    actions.appendChild(addMoreBtn);

    row.appendChild(actions);

    // Event: selecting a product renders its options
    productSelect.addEventListener('change', function () {
      const product = quoteData.products.find(p => p.handle === this.value);
      renderOptions(optionsContainer, product || null);
    });

    return row;
  }

  // -- Initialize with first product row
  if (productRows) {
    productRows.appendChild(createProductRow());
  }

  // -- Hide the original add button (replaced by in-row button)
  if (addBtn) {
    addBtn.style.display = 'none';
  }

  // -- Event delegation: Remove row + Add More Product
  if (productRows) {
    productRows.addEventListener('click', function (e) {

      // Remove row (minimum 1 row must remain)
      if (e.target.classList.contains('remove-row')) {
        if (document.querySelectorAll('.product-row').length > 1) {
          e.target.closest('.product-row').remove();
        }
      }

      // Add another product row
      if (e.target.classList.contains('add-more-product')) {
        productRows.appendChild(createProductRow());
        productRows.lastElementChild.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

    });
  }

  // -- Clear form
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      form.reset();
      productRows.innerHTML = '';
      productRows.appendChild(createProductRow());
      generateCaptcha();
      errorBox.style.display = 'none';
    });
  }

  // -- Show error message
  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.style.display = 'block';
    errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // -- Form submission
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorBox.style.display = 'none';

      // Honeypot check
      if (document.getElementById('website').value) {
        modal.style.display = 'flex';
        return;
      }

      // Time check: block submissions under 3 seconds
      const elapsed = Date.now() - parseInt(loadedAtField.value, 10);
      if (elapsed < 3000) {
        showError('Please take a moment to review your request before submitting.');
        return;
      }

      // CAPTCHA check
      const userAnswer = parseInt(document.getElementById('captcha-answer').value, 10);
      if (isNaN(userAnswer) || userAnswer !== captchaAnswer) {
        showError('Incorrect security answer. Please try again.');
        generateCaptcha();
        return;
      }

      // Validate contact fields
      const name  = document.getElementById('contact-name').value.trim();
      const email = document.getElementById('contact-email').value.trim();
      const phone = document.getElementById('contact-phone').value.trim();

      if (!name) {
        showError('Full name is required.');
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email) {
        showError('Email is required.');
        return;
      }
      if (!emailRegex.test(email)) {
        showError('Invalid email address. Please enter a valid email (e.g. name@example.com).');
        return;
      }

      const phoneRegex = /^[0-9+\-\s()]{7,20}$/;
      if (!phone) {
        showError('Phone is required.');
        return;
      }
      if (!phoneRegex.test(phone)) {
        showError('Invalid phone number. Please enter numbers only (e.g. 0123456789).');
        return;
      }

      // Validate and build product list
      const productLines = [];
      let hasError = false;

      document.querySelectorAll('.product-row').forEach((row, i) => {
        if (hasError) return;

        const productEl = row.querySelector('.product-select');
        const product   = productEl.selectedOptions[0]?.textContent || '';

        if (!product || product === 'Select Product') return;

        const widthInput  = row.querySelector('.size-width-input');
        const heightInput = row.querySelector('.size-height-input');

        if (widthInput && !widthInput.value.trim()) {
          showError(`Product ${i + 1}: Please enter Width.`);
          hasError = true;
          return;
        }
        if (heightInput && !heightInput.value.trim()) {
          showError(`Product ${i + 1}: Please enter Height.`);
          hasError = true;
          return;
        }

        const qtyInput = row.querySelector('.qty-input');
        if (!qtyInput.value || parseInt(qtyInput.value) < 1) {
          showError(`Product ${i + 1}: Please enter a valid quantity.`);
          hasError = true;
          return;
        }

        const details = [];
        if (widthInput?.value.trim())  details.push(`Width: ${widthInput.value.trim()}`);
        if (heightInput?.value.trim()) details.push(`Height: ${heightInput.value.trim()}`);

        row.querySelectorAll('.dynamic-option-select').forEach(sel => {
          if (sel.value) details.push(`${sel.dataset.optionName}: ${sel.value}`);
        });

        details.push(`Qty: ${qtyInput.value}`);

        productLines.push(
          `${i + 1}. ${product}` +
          (details.length ? ` (${details.join(', ')})` : '')
        );
      });

      if (hasError) return;

      if (productLines.length === 0) {
        showError('Please select at least one product.');
        return;
      }

      const note     = document.getElementById('contact-message').value.trim();
      const referral = document.getElementById('referral').value;

      const bodyText =
        `ESTIMATE REQUEST\n\n` +
        `Products requested:\n${productLines.join('\n')}\n\n` +
        `Phone: ${phone}\n` +
        `Heard about us via: ${referral}\n\n` +
        `Notes:\n${note || 'N/A'}`;

      const formData = new FormData();
      formData.append('form_type', 'contact');
      formData.append('utf8', '✓');
      formData.append('contact[name]', name);
      formData.append('contact[email]', email);
      formData.append('contact[body]', bodyText);

      fetch('/contact', { method: 'POST', body: formData })
        .then(() => {
          modal.style.display = 'flex';
          form.reset();
          productRows.innerHTML = '';
          productRows.appendChild(createProductRow());
          generateCaptcha();
        })
        .catch(() => showError('Something went wrong. Please try again.'));
    });
  }

  // -- Close thank you modal
  const closeModalBtn = document.getElementById('close-modal');
  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }

});